import React, {useEffect} from "react";
import {motion, AnimatePresence, useAnimation} from "framer-motion"

function _ConnectLine(props) {
    const controls = useAnimation()

    const icon = {
        hidden: {
            x: 0,
        },
        visible: {
            x: 420 - 160,
        }
    }

    useEffect(() => {
        controls.start("hidden")
        controls.start("visible")
    })

    return (
        <AnimatePresence>
            {/*<text>{props.rand}</text>*/}
            {
                props.show && <motion.line
                    x1="160" y1="240" x2="160" y2="400"
                    variants={icon}
                    initial="hidden"
                    animate={controls}
                    exit={{ opacity: 0 }}
                    opacity={1}
                    stroke={"#142599"}
                    style={{strokeWidth: 2}}
                    // onAnimationComplete={onComplete}
                    transition={{
                        default: {
                            type: 'spring',
                            damping: 300,
                            // duration: 4,
                            // yoyo: Infinity,
                        },
                    }}/>
            }
        </AnimatePresence>

    )

}

export default _ConnectLine

